import { type ReactNode } from 'react';
import cn from 'clsx';
import { Button } from '@base-ui/react/button';

import styles from './ImageButton.module.css';

export type ImageButtonProps = Omit<Button.Props, 'className'> & {
  className?: string;
  children: ReactNode;
};

// TODO: NS-12639 Remove this component once the ui-core equivalent fits this use case. https://engelvoelkers.atlassian.net/browse/SPEAR-5308
export const ImageButton = ({ className, children, ...props }: ImageButtonProps) => {
  return (
    <Button {...props} className={cn(styles.imageButton, className)} type="button">
      {children}
    </Button>
  );
};
